__webpack_require__.p = "//cdn.livechat-static.com/webapp/";